package floris.graphics.models.domain.models.user

import floris.graphics.models.domain.models.interfaces.DateAble
import floris.graphics.models.dto.requests.user.NameAble
import floris.graphics.models.dto.requests.user.UserDto
import kotlinx.serialization.Transient

data class User(
    val id: String = "",
    override val fullName: String = "",
    val username: String = "",
    override val createdAt: String = "",
    override val updatedAt: String = "",
    val role: UserRoles = UserRoles.User,
    @Transient val password: String? = null,
) : DateAble, NameAble

fun User.toDto() = UserDto(
    id = this.id,
    fullName = this.fullName,
    username = this.username,
    createdAt = this.createdAt,
    updatedAt = this.updatedAt,
    role = this.role
)

enum class UserRoles {
    User,
    Admin
}

fun UserDto.toUser() = User(
    id = this.id,
    fullName = fullName,
    username = username,
    createdAt = createdAt,
    updatedAt = updatedAt,
    role = role
)